import * as types from "./types.js"
import * as api from "./api.js"


function getPersonRequest() {
    return {
        type: types.GET_PERSON_REQUEST
    }
}

function getPersonReceived(person) {
    return {
        type: types.GET_PERSON_RECEIVED,
        payload: person
    }
}

function getPersonError(e) {
    return {
        type: types.GET_PERSON_ERROR,
        payload: e,
        error: true
    }
}

export function getPerson(id) {
    return dispatch => {
        dispatch(getPersonRequest())
        return api.getPerson(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getPersonError(res.statusText))
            } else {
                return res.json()
                .then(person => {
                    dispatch(getPersonReceived(person))
                })
            }
        })
    }
}

function putPersonRequest() {
    return {
        type: types.PUT_PERSON_REQUEST
    }
}

function putPersonReceived(person) {
    return {
        type: types.PUT_PERSON_RECEIVED,
        payload: person
    }
}

function putPersonError(e) {
    return {
        type: types.PUT_PERSON_ERROR,
        payload: e,
        error: true
    }
}

export function putPerson(person) {
    return dispatch => {
        dispatch(putPersonRequest())
        return api.putPerson(person)
        .then(res => {
            if (res.status !== 200) {
                dispatch(putPersonError(res.statusText))
            } else {
                return res.json()
                .then(person => {
                    dispatch(putPersonReceived(person))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/person/actions.js
 **/